import { useEffect, useState } from "react";

import { useAuth } from "../../contexts/AuthContext";
import useWilmaUsers from "../../data/useWilmaUsers";
import stringToColour from "../../utils/stringToColour";
import { IWilmaUser } from "./../../models/auth/WilmaUser";
import classNames from "../../utils/classNames";
import Tooltip from "../shared/Tooltip";

interface AvatarProps {
  classes?: string;
  userId?: string;
  textClasses?: string;
  onClick?: () => void;

  tooltipPrefix?: string;
}

/**  Returns an avatar for the user
 If a userId is provided as a prop avatar will attempt to look it up
 If no userId is provided it will default to the logged in user */
export default function Avatar({
  classes,
  userId,
  textClasses,
  onClick,
  tooltipPrefix,
}: AvatarProps) {
  const { userId: ctxUserId, forename, surname, email, loading } = useAuth();
  const { wilmaUsers } = useWilmaUsers(true);
  const [foundUser, setFoundUser] = useState<Partial<IWilmaUser>>();

  useEffect(() => {
    if (!loading && !wilmaUsers.isLoading && wilmaUsers.data) {

      // console.log(wilmaUsers.data)

      // console.log("found user", wilmaUsers.data.data.find((u) => u.id === userId))

      if (userId) {
        setFoundUser(wilmaUsers.data.data.find((u) => u.id === userId)!);
      } else {
        setFoundUser({
          id: ctxUserId!,
          forename: forename!,
          surname: surname!,
          email: email!,
        });
      }
    }
  }, [wilmaUsers.isLoading, wilmaUsers.data, loading, userId]);


  const handleNotFoundClick = () => {

    //Still loading, not done yet
    if (!foundUser && loading) return;

    //If no one found we still want the onClick to work
    onClick?.();
  };

  if (!foundUser) {
    return (
      <div onClick={handleNotFoundClick} className="h-9 w-9 bg-gray-200 rounded-full animate-pulse"></div>
    );
  }

  return (
    <div onClick={onClick} className={`${classes} aspect-square`}>
      <span
        style={{ background: stringToColour(foundUser!.id) }}
        className="w-full h-full inline-flex items-center justify-center rounded-full"
      >
        <Tooltip content={tooltipPrefix ? `${tooltipPrefix} - ${foundUser.forename} ${foundUser.surname}` : `${foundUser.forename} ${foundUser.surname}`}>

          <span
            className={classNames(
              "text-lg leading-none text-white",
              textClasses ? textClasses : ""
            )}
          >
            {`${foundUser.forename} ${foundUser.surname}`
              .split(" ")
              .filter((w) => RegExp(/^\p{L}/, "u").test(w))
              .map((w, i) => (i < 2 ? w.substring(0, 1).toUpperCase() : ""))}
          </span>
        </Tooltip>
      </span>
    </div>
  );
}
